var map = {
	"./afghanistan.svg": 95491,
	"./albania.svg": 93025,
	"./algeria.svg": 78700,
	"./andorra.svg": 28418,
	"./angola.svg": 81457,
	"./antigua-and-barbuda.svg": 50638,
	"./arab.svg": 82187,
	"./argentina.svg": 32898,
	"./armenia.svg": 51472,
	"./australia.svg": 57291,
	"./austria.svg": 16328,
	"./azerbaijan.svg": 69940,
	"./bahamas.svg": 78734,
	"./bahrain.svg": 85654,
	"./bangladesh.svg": 36716,
	"./barbados.svg": 46101,
	"./belarus.svg": 10805,
	"./belgium.svg": 45578,
	"./belize.svg": 57530,
	"./benin.svg": 551,
	"./bhutan.svg": 49907,
	"./bolivia-plurinational-state-of.svg": 85208,
	"./bosnia-and-herzegovina.svg": 65876,
	"./botswana.svg": 84262,
	"./botswana_1.svg": 37142,
	"./brazil.svg": 94029,
	"./brunei-darussalam.svg": 51504,
	"./bulgaria.svg": 47188,
	"./burkina-faso.svg": 1543,
	"./burundi.svg": 16306,
	"./cabo-verde.svg": 41239,
	"./cambodia.svg": 30113,
	"./cameroon.svg": 25239,
	"./canada.svg": 321,
	"./cape-verde.svg": 54791,
	"./central-african-republic.svg": 40766,
	"./chad.svg": 93153,
	"./chile.svg": 63582,
	"./china.svg": 16232,
	"./colombia.svg": 98149,
	"./comoros.svg": 75383,
	"./congo.svg": 46147,
	"./costa-rica.svg": 61681,
	"./cote-d'ivoire.svg": 8028,
	"./cote-d-ivoire.svg": 81574,
	"./croatia.svg": 26242,
	"./cuba.svg": 87844,
	"./cyprus.svg": 24057,
	"./czechia.svg": 31342,
	"./democratic-republic-of-the-congo.svg": 57552,
	"./denmark.svg": 88367,
	"./djibouti.svg": 33569,
	"./dominica.svg": 84105,
	"./dominican-republic.svg": 88722,
	"./dr-congo.svg": 97660,
	"./east-timor.svg": 62590,
	"./ecuador.svg": 22016,
	"./egypt.svg": 71008,
	"./el-salvador.svg": 94795,
	"./england.svg": 18206,
	"./equatorial-guinea.svg": 54010,
	"./eritrea.svg": 25283,
	"./estonia.svg": 47048,
	"./eswatini.svg": 26077,
	"./ethiopia.svg": 20226,
	"./fiji.svg": 46087,
	"./finland.svg": 62505,
	"./france.svg": 6110,
	"./gabon.svg": 59480,
	"./gambia.svg": 52452,
	"./georgia.svg": 39173,
	"./germany.svg": 32018,
	"./ghana.svg": 34444,
	"./greece.svg": 15406,
	"./grenada.svg": 60515,
	"./guatemala.svg": 19078,
	"./guinea-bissau.svg": 13762,
	"./guinea.svg": 76204,
	"./guyana.svg": 56374,
	"./haiti.svg": 27254,
	"./holy-see.svg": 86467,
	"./honduras.svg": 87119,
	"./hong-kong-sar-china.svg": 17826,
	"./hungary.svg": 37427,
	"./iceland.svg": 78839,
	"./india.svg": 46820,
	"./indonesia.svg": 56859,
	"./iran-islamic-republic-of.svg": 64551,
	"./iraq.svg": 60448,
	"./ireland.svg": 14932,
	"./israel.svg": 91383,
	"./italy.svg": 77284,
	"./ivory-coast.svg": 80171,
	"./jamaica.svg": 4667,
	"./japan.svg": 23137,
	"./jordan.svg": 79365,
	"./kazakhstan.svg": 71801,
	"./kenya.svg": 51161,
	"./kiribati.svg": 82794,
	"./korea-republic-of.svg": 37866,
	"./kuwait.svg": 13232,
	"./kyrgyzstan.svg": 54275,
	"./lao-people-s-democratic-republic.svg": 44310,
	"./lao-people’s-democratic-republic.svg": 9186,
	"./latvia.svg": 83578,
	"./lebanon.svg": 15630,
	"./lesotho.svg": 30255,
	"./liberia.svg": 199,
	"./libya.svg": 33918,
	"./liechtenstein.svg": 98014,
	"./lithuania.svg": 36612,
	"./luxembourg.svg": 18843,
	"./macau-sar-china.svg": 83101,
	"./macedonia.svg": 14134,
	"./madagascar.svg": 92055,
	"./malawi.svg": 45040,
	"./malaysia.svg": 93846,
	"./maldives.svg": 37220,
	"./mali.svg": 30396,
	"./malta.svg": 73882,
	"./marshall-islands.svg": 26700,
	"./mauritania.svg": 42892,
	"./mauritius.svg": 89576,
	"./mexico.svg": 45066,
	"./micronesia.svg": 88387,
	"./moldova.svg": 29769,
	"./monaco.svg": 55702,
	"./mongolia.svg": 76065,
	"./montenegro.svg": 92585,
	"./morocco.svg": 63355,
	"./mozambique.svg": 78949,
	"./myanmar.svg": 11296,
	"./namibia.svg": 64298,
	"./nauru.svg": 45818,
	"./nepal.svg": 84331,
	"./netherlands.svg": 59921,
	"./new-zealand.svg": 83667,
	"./nicaragua.svg": 51424,
	"./niger.svg": 3442,
	"./nigeria.svg": 94852,
	"./north-korea.svg": 51281,
	"./north-macedonia.svg": 41920,
	"./norway.svg": 53133,
	"./oman.svg": 69990,
	"./pakistan.svg": 76678,
	"./palau.svg": 93452,
	"./palestine.svg": 36352,
	"./panama.svg": 81167,
	"./papua-new-guinea.svg": 16793,
	"./paraguay.svg": 27439,
	"./peru.svg": 5849,
	"./philippines.svg": 84948,
	"./poland.svg": 84519,
	"./portugal.svg": 22029,
	"./qatar.svg": 69186,
	"./rebublic-congo.svg": 5636,
	"./romania.svg": 5224,
	"./russian-federation.svg": 54168,
	"./rwanda.svg": 79022,
	"./saint-kitts-and-nevis.svg": 91694,
	"./saint-lucia.svg": 76807,
	"./saint-vincent-and-the-grenadines.svg": 47963,
	"./samoa.svg": 13536,
	"./san-marino.svg": 60384,
	"./sao-tome-and-principe.svg": 26141,
	"./saudi-arabia.svg": 2140,
	"./senegal.svg": 2252,
	"./serbia.svg": 51365,
	"./seychelles.svg": 37602,
	"./sierra-leone.svg": 74557,
	"./singapore.svg": 44339,
	"./slovakia.svg": 83739,
	"./slovenia.svg": 73582,
	"./solomon-islands.svg": 23029,
	"./south-africa.svg": 95549,
	"./south-korea.svg": 78999,
	"./south-sudan.svg": 8816,
	"./spain.svg": 56274,
	"./sri-lanka.svg": 98587,
	"./st--kitts-and-nevis.svg": 51875,
	"./st--lucia.svg": 78738,
	"./st--vincent-and-the-grenadines.svg": 26048,
	"./st.-kitts-and-nevis.svg": 29836,
	"./st.-lucia.svg": 7865,
	"./st.-vincent-and-the-grenadines.svg": 92461,
	"./sudan.svg": 23792,
	"./suriname.svg": 14613,
	"./swaziland.svg": 91802,
	"./sweden.svg": 94927,
	"./switzerland.svg": 60902,
	"./syria.svg": 28857,
	"./taiwan-china.svg": 47525,
	"./tajikistan.svg": 36645,
	"./tanzania-united-republic-of.svg": 61322,
	"./thailand.svg": 9482,
	"./timor-leste.svg": 30862,
	"./togo.svg": 86998,
	"./tonga.svg": 97106,
	"./trinidad-and-tobago.svg": 22315,
	"./tuerkiye-turkey.svg": 78432,
	"./tunisia.svg": 98190,
	"./turkmenistan.svg": 55730,
	"./tuvalu.svg": 46484,
	"./uganda.svg": 87319,
	"./ukraine.svg": 77130,
	"./united-arab-emirates.svg": 44100,
	"./united-kingdom.svg": 70418,
	"./united-states.svg": 48665,
	"./uruguay.svg": 72429,
	"./uzbekistan.svg": 817,
	"./vanuatu.svg": 28637,
	"./venezuela-bolivarian-republic-of.svg": 57501,
	"./viet-nam.svg": 93608,
	"./yemen.svg": 44635,
	"./zambia.svg": 16455,
	"./zimbabwe.svg": 40180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6314;